import { groupBy as groupby } from 'lodash-es';
import { TYPE_STRING, TYPE_COLLECTION, TYPE_DATE_COMPARISON, TYPE_ENUM } from './options/input-types';
import { convertFilterToLegacyApiFilter } from './filter-to-api-filter-converter';
import { options } from './options';

const filterTypeToApiFilterMap = {
  [TYPE_STRING]: {
    createFilter: ({ value, apiFilter }) => {
      const trimValue = value.filter((v) => v.trim());
      if (trimValue.length > 0) {
        return { [apiFilter]: value[0] };
      }
    },
  },
  [TYPE_COLLECTION]: {
    createFilter: ({ value, apiFilter }) => {
      if (value.length > 0) {
        return { [apiFilter]: value[0] };
      }
    },
  },
  [TYPE_DATE_COMPARISON]: {
    createFilter: ({ value, apiFilter }) => {
      const { from, to } = value;
      const fromFilter =
        from != null
          ? {
              [`${apiFilter}After`]: from,
            }
          : {};
      const toFilter =
        to != null
          ? {
              [`${apiFilter}Before`]: to,
            }
          : {};
      return { ...fromFilter, ...toFilter };
    },
  },
  [TYPE_ENUM]: {
    createFilter: ({ value, apiFilter }) => ({
      [apiFilter]: value,
    }),
  },
};

const getApiFilterFromFilter = (filter, type, customFilterMap) => {
  const { id, value, operator } = filter;
  const apiFilter = convertFilterToLegacyApiFilter(id);
  const map = customFilterMap || filterTypeToApiFilterMap;
  return map[type].createFilter({ apiFilter, value, operator });
};

export const legacyApiFilterBuilder = (filters, customFilterMap) => {
  // Filter out any filters that don't exist in view
  const validFilters = filters.filter((filter) => options[filter.id] != null);

  const groupedFilters = groupby(validFilters, (filter) => options[filter.id].type);
  const groupKeys = Object.keys(groupedFilters);
  const apiFilters = groupKeys.reduce((body, groupKey) => {
    const apiFilterGroup = groupedFilters[groupKey].reduce((acc, filter) => {
      const apiFilter = getApiFilterFromFilter(filter, groupKey, customFilterMap);
      if (apiFilter) {
        return {
          ...acc,
          ...apiFilter,
        };
      }

      return acc;
    }, {});

    return {
      ...body,
      ...apiFilterGroup,
    };
  }, {});

  return apiFilters;
};
